<template lang='pug'>
  app-plotly(nomeDiv='graficoQuantidadeProcessso', :dados='graficoDados', :layout='layout')
</template>

<script>
import AppPlotly from '@/components/AppPlotly'

import { tipoCadastroDescricao, colors } from '../../../utils/constantes'

export default {
  components: {
    AppPlotly
  },

  props: {
    dadosLabels: {
      type: Array,
      required: true
    }
  },

  data () {
    return {
      dados: [],
      loading: true
    }
  },
  computed: {
    dadosWithColor () {
      return this.dadosLabels.map((dado, index) => ({
        ...dado,
        tipoProcesso: tipoCadastroDescricao[dado.label],
        color: colors[index]
      }))
    },

    graficoDados () {
      if (_.isEmpty(this.dadosLabels)) {  // eslint-disable-line
        return []
      }
      const graficoDados = [{
        x: [],
        y: [],
        text: [],
        textfont: {
          size: 14
        },
        textposition: 'auto',
        hoverinfo: 'none',
        marker: { color: [] },
        type: 'bar',
        width: this.dadosWithColor.length > 2 ? 0.8 : 0.2
      }]

      for (let index = 0; index < this.dadosWithColor.length; index++) {
        graficoDados[0].x.push(this.dadosWithColor[index].tipo)

        graficoDados[0].y.push(this.dadosWithColor[index].quantidade)

        graficoDados[0].text.push(this.dadosWithColor[index].quantidade.toString())

        graficoDados[0].marker.color.push(this.dadosWithColor[index].color)
      }

      return graficoDados
    },

    layout () {
      return {
        showlegend: false,
        xaxis: {
          title: '',
          tickfont: {
            size: 14,
            color: 'rgb(107, 107, 107)'
          }
        },
        yaxis: {
          title: 'Quantidade de processo',
          titlefont: {
            size: 16,
            color: 'rgb(107, 107, 107)'
          },
          tickfont: {
            size: 14,
            color: 'rgb(107, 107, 107)'
          }
        },
        bargap: 0.15,
        bargroupgap: 0.1
      }
    },
    hasData () {
      return !_.isEmpty(this.dados)   // eslint-disable-line
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/screens/produtividade/components/GraficoQuantidadeProcesso.vue